module.exports = __webpack_public_path__ + "yeni ofis 10.jpeg?5daac911a9a9de675f179e4329fae135";


//////////////////
// WEBPACK FOOTER
// ./src/HtmlFiles/img/yeni ofis 10.jpeg
// module id = 385
// module chunks = 0